import service from './index';

export default {
  async getInventoryCenterHistory (listingId) {
    const response = await service.get(`inventory-center/history/${listingId}`);
    return response;
  },
};
